export class SliderPosition {
    constructor(public h: number, public s: number, public v: number, public a: number) {}
}
  
export class SliderDimension {
    constructor(public h: number, public s: number, public v: number, public a: number) {}
}